
class InfiniteScrollController {
  constructor({
    gridSelector,
    rowSelector,
    triggerSelector,
    loadingSelector,
    preloadFactor = 1.8,
    onAppend = null
  }) {
    this.grid = document.querySelector(gridSelector);
    if (!this.grid) return;

    this.rowSelector = rowSelector;
    this.trigger = document.querySelector(triggerSelector);
    this.loading = document.querySelector(loadingSelector);

    this.preloadFactor = preloadFactor;
    this.onAppend = onAppend;

    this.nextUrl = this.grid.dataset.nextUrl;
    this.isLoading = false;

    this.supportsObserver = 'IntersectionObserver' in window;

    if (this.supportsObserver) {
      this.setupObserver();
    } else {
      // fallback
      this.setupScrollFallback();
    }

    this.autoPreload();
  }

  setupObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && this.nextUrl && !this.isLoading) {
          this.loadMore();
        }
      });
    }, {
      rootMargin: '2000px 0px 2000px 0px'
    });

    this.observer.observe(this.trigger);
  }


  setupScrollFallback() {
    this.scrollHandler = () => {
      const scrollY = window.scrollY + window.innerHeight;
      const threshold = document.body.offsetHeight - 1200;

      if (scrollY >= threshold) {
        this.loadMore();
      }
    };

    window.addEventListener('scroll', this.scrollHandler, { passive: true });
  }

autoPreload() {
  const interval = setInterval(() => {
    if (!this.nextUrl || this.isLoading) {
      clearInterval(interval);
      return;
    }

    const fullHeight = document.body.offsetHeight;
    const screenHeight = window.innerHeight;

    if (fullHeight < screenHeight * 3.5) { 
      this.loadMore();
    }
  }, 400);
}


async loadMore() {
  if (!this.nextUrl || this.isLoading) return;
  this.isLoading = true;

  if (this.loading) this.loading.classList.remove('hidden');

  try {
    // Merge nextUrl + current filter params
    const currentParams = new URLSearchParams(window.location.search);
    const nextUrlObj = new URL(this.nextUrl, window.location.origin);

    currentParams.forEach((val, key) => {
      nextUrlObj.searchParams.set(key, val);
    });

    const url = nextUrlObj.toString();

    console.log("[InfiniteScroll] Fetching:", url);

    // Fetch HTML
    const res = await fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!res.ok) throw new Error(res.status);

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");

    // New grid and next URL
    const newGrid = doc.querySelector("#ProductsGrid");
    const newRow = newGrid?.querySelector(".row.g-2.g-md-3");
    const newNext = newGrid?.dataset.nextUrl;

    if (!newGrid) {
      console.warn("[InfiniteScroll] No newGrid found");
      this.nextUrl = null;
      return;
    }

    if (newRow) {
      const targetRow = this.grid.querySelector(".row.g-2.g-md-3");

      // append only children
      const items = Array.from(newRow.children);
      items.forEach(el => {
        targetRow.appendChild(el);
      });

      if (this.onAppend) this.onAppend(newRow);

      // update next URL
      this.nextUrl = newNext ?? null;
    } else {
      console.warn("[InfiniteScroll] newRow empty, no more products");
      this.nextUrl = null;
    }

  } catch (e) {
    console.error("[InfiniteScroll] Error:", e);
    this.nextUrl = null;
  } finally {
    this.isLoading = false;
    if (this.loading) this.loading.classList.add("hidden");
  }
}



  forceLoad() {
    this.loadMore();
  }

  destroy() {
    if (this.observer) this.observer.disconnect();
    if (this.scrollHandler) window.removeEventListener('scroll', this.scrollHandler);
  }
}

class InfinityProducts extends HTMLElement {

  connectedCallback() {
    this.initController();
  }

  initController() {
    this.controller?.destroy();

    this.controller = new InfiniteScrollController({
      gridSelector: '#ProductsGrid',
      rowSelector: '.row',
      triggerSelector: '#infinite-trigger',
      loadingSelector: '#loading-indicator',
      preloadFactor: 2.2,
      onAppend: () => {
        console.log('[InfinityProducts] Products appended');
      }
    });
  }

  refresh() {
    console.log('[InfinityProducts] Refresh triggered');
    this.initController();
  }

  disconnectedCallback() {
    this.controller?.destroy();
  }

  forceLoad() {
    this.controller?.forceLoad();
  }
}

customElements.define('infinity-products', InfinityProducts);


